//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import setShareConfig from '@/js/wxShare.js'
import subLength from '@/common/library/subLength.js'
// import myContent from '../scenicTutorials/components/content.vue'
import commentList from '@/components/commentList/index.vue'
import showMask from '@/components/mask/mask.vue'
import moreContent from '@/components/more-content/index.vue'
import uniPopup from "@/components/uni-popup/uni-popup.vue"
import uniRate from "@/components/uni-rate/uni-rate.vue"
import uParse from '@/components/gaoyia-parse/parse.vue'
var view, view2, view3, top1, top2, top3
export default {
  name: 'scenic-spot-detail',
  components: {
    moreContent, commentList, showMask, uniPopup, uniRate, uParse
  },
  data() {
    return {
      //swiper轮播图
      indicatorDots: false, //是否显示面板指示点
      circular: true, //是否采用衔接滑动
      autoplay: true, //是否自动切换
      interval: 3000, //自动切换时间间隔
      duration: 500, //滑动动画时长
      imgList: [], //轮播图数组
      current: 1, //当前所在滑块
      currentLength: 0, //图片总数
      id: '',

      scenicspotInfo: '',
      tickets: '',
      scenicspotId: '',
      tagList: [],
      isWeixin: true,
      isTop: false,
      scrollTop: 0,
      intoView: '',
      navName: 'div1',
      navBarList: [
        { id: 'div1', name: '门票预订' },
        { id: 'div2', name: '景区详情' },
        { id: 'div3', name: '用户评价' }
      ],
      showTicket: false,
      ticket: {},
      submitLoading: false,
      checkAll: false,
      // 评论相关
      commentObj: {
        total: 0,
        starLevel: 5
      }
    }
  },
  computed: {
    rank() {
      let a = 'AAAAA'
      return this.scenicspotInfo.starType === 1 ? '其他' : a.substr(0, this.scenicspotInfo.starType)
    },
    address() {
      return this.scenicspotInfo.detailAddress ? subLength(this.scenicspotInfo.detailAddress, 15) : ''
    }
  },
  onLoad(event) {
    this.scenicspotId = event.id





    this.queryData()
    this.queryCommentList()
  },
  onReady() {
    view = uni.createSelectorQuery().select("#div1");
    view2 = uni.createSelectorQuery().select("#div2");
    view3 = uni.createSelectorQuery().select("#div3");
  },
  methods: {
    //顶部轮播图当前图片页数
    changeImg(event) {
      this.current = event.detail.current + 1
    },
    queryData() {
      this.$ajax({
        method: 'post',
        url: '/weChat/ticket/queryScenicDetail',
        data: {
          bodyId: this.scenicspotId
        }
      }).then((result) => {
        // 3.0 返回数据结构有变化
        let scenicspot = {
          ...result.data,
          // bodyId: this.scenicspotId,
          scenicspotId: this.scenicspotId
          // coverImagesUrl: result.data.cover,
          // rank: result.data.starType, 
        }
        // setShareConfig(scenicspot.scenicName, '', window.location.hash.split('#')[1], this.$getImg(scenicspot.cover))
        this.scenicspotInfo = scenicspot
        this.tickets = result.data.wctProductListDtoList
        this.imgList = scenicspot.images ? scenicspot.images.split(',') : []
        this.currentLength = this.imgList.length
        this.tagList = scenicspot.labelName ? scenicspot.labelName.split(',') : []
      })
    },
    jump() {
      uni.navigateTo({
        url: '/pages/common/images?image=' + this.imgList
      })
    },
    showPosition() {
      if (this.scenicspotInfo.latitude && this.scenicspotInfo.longitude) {
















        wx.openLocation({
          latitude: parseFloat(this.scenicspotInfo.latitude), // 纬度，浮点数，范围为90 ~ -90
          longitude: parseFloat(this.scenicspotInfo.longitude), // 经度，浮点数，范围为180 ~ -180。
          name: this.scenicspotInfo.bodyName, // 位置名
          address: this.scenicspotInfo.detailAddress, // 地址详情说明
          scale: 16, // 地图缩放级别,整形值,范围从1~28。默认为最大
          infoUrl: '' // 在查看位置界面底部显示的超链接,可点击跳转
        })

      }
    },
    handleClick(ticket) {
      this.showTicket = true
      this.$ajax({
        method: 'post',
        url: '/weChat/ticket/queryProductDetail',
        data: {
          id: ticket.id,
          sProductId: ticket.sProductId,
          aProductId: ticket.aProductId,
          productTypeCode: ticket.productTypeCode,
          currentPage: 1,
          pageSize: 1000
        }
      }).then((result) => {
        let res = {
          ...result.data
        }
        if (res.cancelType === 1) {
          res.cancelType = '可退，需确认'
        } else if (res.cancelType === 2) {
          res.cancelType = '一经出售概不退换'
        } else {
          res.cancelType = '不可退'
        }
        // setShareConfig(res.name, '', window.location.hash.split('#')[1], this.$getImg(res.cover))
        this.ticket = {
          ...res,
          ticketId: this.ticketId,
          showText: true,
          unit: '分'
          // ...selected[0],
          // ...res.scenicspot,
          // cover: selected[0].cover,
          // ticketId: this.ticketId,
          // scenicspotId: this.scenicspotId,
        }
      })
    },
    submit() {
      uni.navigateTo({
        // url: `/pages/touristAttraction/order?id=${this.ticket.id}&query=${encodeURIComponent(JSON.stringify({ sProductId: this.ticket.sProductId, aProductId: this.ticket.aProductId, productTypeCode: this.ticket.productTypeCode, scenicspotId: this.ticket.bodyId }))}`
        url: `/pages/touristAttraction/order?id=${this.ticket.id}`
      })
    },
    cancelMask() {
      this.showTicket = false;
    },
    scroll(e) {
      let _top = e.detail.scrollTop
      let _this = this
      view.boundingClientRect(data => {
        top1 = data.top - 50
      }).exec();
      if (top1 <= 0) {
        this.isTop = true
      } else {
        this.isTop = false
      }
      view2.boundingClientRect(function (data) {
        top2 = data.top - 50
      }).exec()
      view3.boundingClientRect(function (data) {
        top3 = data.top - 50
      }).exec()
      if (top1 < 0 && top2 > 0) {
        this.navName = 'div1'
      } else if (top2 <= 0 && top3 > 0) {
        this.navName = 'div2'
      } else if (top3 <= 0) {
        this.navName = 'div3'
      }
      this.intoView = ''
    },
    scrollTo(e) {
      this.navName = e
      this.intoView = e
    },
    queryCommentList(status) {
      this.$ajax({
        method: 'post',
        url: '/weChat/comment/list',
        data: {
          currentPage: '',
          pageSize: '',
          productId: '',
          bodyId: this.scenicspotId,
          commentatorId: this.$store.state.userInfo.memberId || ''
        }
      }).then(data => {
        this.$set(this.commentObj, 'data', data)
        this.commentObj.total = data.count
        this.commentObj.starLevel = parseInt(data.dataObj || 0)
      })
    },
    toCommentList() {
      uni.navigateTo({
        url: `/pages/comment/list?bodyId=${this.scenicspotId}&productId=`
      })
    }
  }
}
